import { connect } from 'react-redux';

import { getBranchingModel, getMainBranch } from 'src/redux/branches';
import { BucketState } from 'src/types/state';

import BranchKindLozenges from '../components/branch-kind-lozenges';

const mapStateToProps = (state: BucketState) => {
  const { production, development } = getBranchingModel(state);
  const main = getMainBranch(state);
  return {
    main: main ? main.name : '',
    production: production ? production.name : '',
    development: development ? development.name : '',
  };
};

export default connect(mapStateToProps)(BranchKindLozenges);
